/**
 * @property COLOR
 * @type {Object}
 * @final
 */
export const COLOR = {
    BLACK_07: 'rgba(0, 0, 0, 0.7)',
    BLUE_02: 'rgba(128, 255, 255, 0.2)',
    BLUE_05: 'rgba(128, 255, 255, 0.5)',
    BLUE_06: 'rgba(128, 255, 255, 0.6)',
    BLUE_09: 'rgba(128, 255, 255, 0.9)',
    BLUE_LIGHT_SOFT_03: 'rgba(150, 200, 255, 0.3)',
    GRAY_LIGHT: 'rgba(224, 224, 224, 1.0)',
    GRAY: 'rgba(150, 150, 150, 1)',
    GREEN_02: 'rgba(76, 118, 97, 0.2)',
    GREEN_05: 'rgba(76, 118, 97, 0.5)',
    GREEN_09: 'rgba(76, 118, 97, 0.9)',
    GREEN_DARK: 'rgba(51, 85, 68, 1)',
    GREEN_LIGHT_PALE_002: 'rgba(200, 255, 200, 0.02)',
    GREEN_LIGHT_PALE_01: 'rgba(200, 255, 200, 0.1)',
    GREEN_LIGHT_PALE_025: 'rgba(200, 255, 200, 0.25)',
    GREEN_LIGHT: 'rgba(193, 218, 205, 1)',
    GREEN_MEDIUM: 'rgba(68, 102, 85, 1)',
    RED_02: 'rgba(224, 128, 128, 0.2)',
    RED_05: 'rgba(224, 128, 128, 0.5)',
    RED_06: 'rgba(224, 128, 128, 0.6)',
    RED_08: 'rgba(224, 128, 128, 0.8)',
    RED_09: 'rgba(224, 128, 128, 0.9)',
    RED_BRIGHT_07: 'rgba(255, 0, 0, 0.7)',
    RED: 'rgba(224, 128, 128, 1.0)',
    WHITE_02: 'rgba(255, 255, 255, 0.2)',
    WHITE_04: 'rgba(255, 255, 255, 0.4)',
    WHITE_05: 'rgba(255, 255, 255, 0.5)',
    WHITE_07: 'rgba(255, 255, 255, 0.7)',
    WHITE_08: 'rgba(255, 255, 255, 0.8)',
    WHITE_09: 'rgba(255, 255, 255, 0.9)',
    WHITE: 'rgba(255, 255, 255, 1.0)'
};
